module.exports = __webpack_public_path__ + "img/image27.20291585.jpg";